import { isObject } from 'lodash'

/**
 * 返回全局变量
 */
export function globalVar() {
  return {
    phone: '400-8566-100',
    qqLink: 'tencent://message/?uin=811028657&Site=&Menu=yes',
    email: 'kefu@jczh100.com',
    workTime: '08:30-17:30'
  }
}

/**
 * 跳转至登录平台
 */
export function toLogin() {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  window.location.href = `${
    process.env.VUE_APP_PASSPORT_URL
  }?returnUrl=${encodeURIComponent(window.location.href)}`
}

/**
 * 跳转会员宣传页
 */
export function toVipPrivilege() {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  const url = process.env.VUE_APP_PORTAL_URL + '/value-added/vip/privilege'
  window.open(url, '_blank')
}

/**
 * 跳转至会员购买页
 */
export function toVipBuy() {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  const url = process.env.VUE_APP_PORTAL_URL + '/value-added/vip/buy'
  window.open(url, '_self')
}

/**
 * 跳转套餐列表页
 */
export function toVipCombo() {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  const url = process.env.VUE_APP_PORTAL_URL + '/value-added/vip/privilege'
  window.open(url, '_blank')
}

/**
 * 跳转至云采购门户公告页
 */
export function toPortalNotice({ noticeId = '', noticeUrl = '' }) {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  const url = noticeId
    ? process.env.VUE_APP_PORTAL_URL + '/project/notice/' + noticeId
    : noticeUrl
  window.open(url, '_blank')
}

/**
 * 跳转到支付中心
 * @param {string} payCode 支付订单号
 */
export function toPayCenter(payCode) {
  // 跳转到支付页面
  const url = process.env.VUE_APP_PAY_URL + '/order/' + payCode
  window.open(url, '_blank')
}

/**
 * 字符串货币格式化
 * @param {string} numStr 数字字符串，可带小数
 */
export function strToThousands(numStr) {
  if (numStr == null || numStr == undefined) return numStr
  return numStr.toString().replace(/\d+/, function (n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ','
    })
  })
}

/**
 * 对象数组去重
 * @param {Array} arr 对象数组
 * @param {string} key 用于识别重复的属性名，默认使用'id'
 */
export function unique(arr, key = 'id') {
  const res = new Map()
  return arr.filter(
    (current) => !res.has(current[key]) && res.set(current[key], 1)
  )
}

/**
 * 将对象转换成页面路径传参的字符串
 * @param {Object} object
 * @returns {string}
 */
export function toStringOnPath(object) {
  if (!isObject(object)) return ''

  const stringArray = []
  for (const key in object) {
    stringArray.push(`${key}=${object[key]}`)
  }
  return stringArray.join('&')
}

/**
 * 解析字符串实现对象属性路径访问
 * @param {Object} obj 要访问的对象
 * @param {String} path 属性路径字符串
 * @returns {null|*} 对应的属性值
 */
export function getPropByPath(obj, path) {
  let tempObj = obj
  path = path?.replace(/\[(\w+)\]/g, '.$1')
  path = path?.replace(/^\./, '')

  const keyArr = path?.split('.') || []
  let i = 0
  for (let len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj) break
    const key = keyArr[i]
    if (key in tempObj) {
      tempObj = tempObj[key]
    } else {
      return null
      // break;
    }
  }
  return tempObj ? tempObj[keyArr[i]] : null
}

/**
 * 字符串按字数限制省略
 * @param {string} str 目标字符串
 * @param {number} size 限制显示的字数
 * @returns {string} 省略后的字符串
 */
export function stringEllipsis(str = '', size = 150) {
  if (str.length > size) {
    str = str.substring(0, size - 1) + '...'
  }
  return str
}
